"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSplitButtonStyle = void 0;
function getSplitButtonStyle(_a) {
    var side = _a.side;
    var style = {};
    switch (side) {
        case "left":
            style = {
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                paddingRight: 8,
            };
            break;
        case "middle":
            style = { borderRadius: 0, paddingRight: 8, paddingLeft: 8 };
            break;
        case "right":
            style = {
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                paddingLeft: 8,
            };
            break;
    }
    return style;
}
exports.getSplitButtonStyle = getSplitButtonStyle;
//# sourceMappingURL=helpers.js.map